import { render, staticRenderFns } from "./PreOrderFormInfo.vue?vue&type=template&id=22ef55ad&scoped=true"
import script from "./PreOrderFormInfo.vue?vue&type=script&lang=js"
export * from "./PreOrderFormInfo.vue?vue&type=script&lang=js"
import style0 from "./PreOrderFormInfo.vue?vue&type=style&index=0&id=22ef55ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ef55ad",
  null
  
)

export default component.exports